// Redesign 2026 – samostatný bundle hledání v blogu (webpack entry `blog-search` -> dist/blog-search.js).
// Načítá includes/redesign/blog-search.php jen na výpisu blogu a rubrik.
import initRedesignBlogSearch from './blog-search';

document.addEventListener('DOMContentLoaded', () => {
  initRedesignBlogSearch(); // našeptávač hledání v blogu ([data-rd-blog-search])
});
